export const TABS_MAPPING = [
  {
    id: 'series',
    label: 'Audio Series',
  },
  {
    id: 'novel',
    label: 'Novel',
  },
];
